module.exports = __webpack_public_path__ + "static/img/guideTips.452599d7.png";